/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum AcknowledgementStanding {
  OVERDUE = "OVERDUE",
  OUTSTANDING = "OUTSTANDING",
  UP_TO_DATE = "UP_TO_DATE",
  NONE_SENT = "NONE_SENT",
}
